export default __webpack_public_path__ + "static/3-20d479410e46eeab48446179ff89c3f7.jpg";